(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[416],{

/***/ 11308:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/article/vender-id/[venderUrlId]",
      function () {
        return __webpack_require__(75781);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 75781:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _venderUrlId_; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(89289);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Box/Box.js + 1 modules
var Box = __webpack_require__(61953);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(79072);
// EXTERNAL MODULE: ./node_modules/@mui/material/esm/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(29630);
// EXTERNAL MODULE: ./node_modules/react-infinite-scroll-component/dist/index.es.js
var index_es = __webpack_require__(58533);
// EXTERNAL MODULE: ./node_modules/lodash-es/flatten.js
var flatten = __webpack_require__(27961);
// EXTERNAL MODULE: ./node_modules/lodash-es/floor.js + 1 modules
var floor = __webpack_require__(34426);
// EXTERNAL MODULE: ./utils/api/hooks/useVenderById.js
var useVenderById = __webpack_require__(20227);
// EXTERNAL MODULE: ./utils/api/hooks/useInfiniteArticles.js
var useInfiniteArticles = __webpack_require__(68138);
// EXTERNAL MODULE: ./utils/api/hooks/useBanners.js
var useBanners = __webpack_require__(13929);
// EXTERNAL MODULE: ./utils/api/hooks/useArticleCount.js
var useArticleCount = __webpack_require__(43921);
// EXTERNAL MODULE: ./store/webview/webviewSlice.js
var webviewSlice = __webpack_require__(86377);
// EXTERNAL MODULE: ./utils/native-notifier.js
var native_notifier = __webpack_require__(11634);
// EXTERNAL MODULE: ./components/common/Layout/index.js
var Layout = __webpack_require__(82023);
// EXTERNAL MODULE: ./components/common/Header/index.js + 2 modules
var Header = __webpack_require__(75883);
// EXTERNAL MODULE: ./components/common/ContentWrapper/index.js
var ContentWrapper = __webpack_require__(55856);
// EXTERNAL MODULE: ./components/common/ArticleListItem/index.js + 1 modules
var ArticleListItem = __webpack_require__(70650);
// EXTERNAL MODULE: ./components/common/InfiniteContainer/index.js
var InfiniteContainer = __webpack_require__(26643);
// EXTERNAL MODULE: ./components/common/ArticleClassifications/index.js
var ArticleClassifications = __webpack_require__(94782);
// EXTERNAL MODULE: ./components/common/LatestArticle/index.js
var LatestArticle = __webpack_require__(87624);
// EXTERNAL MODULE: ./components/common/Hidden/index.js
var Hidden = __webpack_require__(18450);
// EXTERNAL MODULE: ./components/common/Divider/index.js
var Divider = __webpack_require__(20293);
// EXTERNAL MODULE: ./components/common/GuessLikesList/index.js + 2 modules
var GuessLikesList = __webpack_require__(26710);
// EXTERNAL MODULE: ./components/common/Banner/index.js
var Banner = __webpack_require__(25820);
// EXTERNAL MODULE: ./components/common/Footer/index.js + 12 modules
var Footer = __webpack_require__(56007);
// EXTERNAL MODULE: ./utils/hooks/analytics/GtmAgent/GtmAgent.js
var GtmAgent = __webpack_require__(27582);
;// CONCATENATED MODULE: ./components/pages/Article/VenderId/index.js

























const VenderId = (param)=>{
    let { fallbackData  } = param;
    var _router_query;
    const router = (0,next_router.useRouter)();
    const venderUrlId = (_router_query = router.query) === null || _router_query === void 0 ? void 0 : _router_query.venderUrlId;
    const { data: venderData  } = (0,useVenderById/* useVenderById */.X)(venderUrlId);
    const { data , size , setSize  } = (0,useInfiniteArticles/* useInfiniteArticles */.g)(()=>({
            venderId: venderUrlId
        }), {
        fallbackData: [
            fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articles
        ]
    });
    const articles = (0,flatten/* default */.Z)(data);
    const articlesIds = articles.slice(0, 20).map((article)=>article._id);
    const webview = (0,es/* useSelector */.v9)(webviewSlice/* selectWebview */.hn);
    const { data: advertisementBanner  } = (0,useBanners/* useBanners */.U)(webview === null || webview === void 0 ? void 0 : webview.name, {
        displayAt: "articleListAdvertisement"
    });
    const bannerList = (0,flatten/* default */.Z)(advertisementBanner);
    const onLoadMore = ()=>{
        setSize(size + 1);
    };
    const { data: articleCount  } = (0,useArticleCount/* useArticleCount */.T)(()=>({
            venderId: venderUrlId
        }), {
        fallbackData: fallbackData === null || fallbackData === void 0 ? void 0 : fallbackData.articleCount
    });
    const handleArticleClick = (article)=>{
        if (!article) return;
        GtmAgent/* GtmAgent.directSendToGTM */.b.directSendToGTM({
            event: "living_action",
            living_event_name: "booking_service_article",
            living_click_name: article === null || article === void 0 ? void 0 : article.title,
            living_click_location: "文章列表頁",
            living_vender: venderData === null || venderData === void 0 ? void 0 : venderData.name,
            living_click_article_id: article === null || article === void 0 ? void 0 : article._id
        });
    };
    const containerId = "scrollable-article-container";
    (0,react.useEffect)(()=>{
        if ((webview === null || webview === void 0 ? void 0 : webview.name) === "lsApp") {
            try {
                (0,native_notifier/* enableNativeHeaderMainTabs */.QL)(false);
                (0,native_notifier/* enableNativeHeaderNavBack */.Gz)(true);
                (0,native_notifier/* enableNativeHeaderSearch */.PP)(false);
            } catch (err) {
                console.error("native notifier error: ", err.message);
            }
        }
    }, [
        webview
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        stickyHeader: /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
        fixContentHeight: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(InfiniteContainer/* default */.Z, {
            id: containerId,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ContentWrapper/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            variant: "headlineSmall",
                            mt: 8,
                            children: [
                                venderData === null || venderData === void 0 ? void 0 : venderData.shortname,
                                "共",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    variant: "headlineSmall",
                                    color: "primary",
                                    component: "span",
                                    children: articleCount
                                }),
                                " ",
                                "篇文章"
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                            container: true,
                            mt: {
                                xs: 12,
                                lg: 18
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    lg: 8,
                                    pr: {
                                        xxl: 12,
                                        maxLimit: 24
                                    },
                                    px: {
                                        md: 8,
                                        lg: 0
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_es/* default */.Z, {
                                            dataLength: (articles === null || articles === void 0 ? void 0 : articles.length) || 0,
                                            hasMore: true,
                                            next: onLoadMore,
                                            scrollableTarget: containerId,
                                            scrollThreshold: 0.6,
                                            children: [
                                                articles === null || articles === void 0 ? void 0 : articles.map((article, index)=>{
                                                    /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                mb: {
                                                                    xs: 8,
                                                                    md: 15
                                                                },
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                                                    onClick: ()=>handleArticleClick(article),
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleListItem/* default */.Z, {
                                                                        article: article
                                                                    })
                                                                })
                                                            }),
                                                            (index + 1) % 10 === 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10) - 1]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* AdvertisementBanner */.Nt, {
                                                                banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10) - 1]
                                                            }) : "",
                                                            index === (articles === null || articles === void 0 ? void 0 : articles.length) - 1 && (index + 1) % 10 !== 0 && (bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10)]) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Banner/* AdvertisementBanner */.Nt, {
                                                                banner: bannerList === null || bannerList === void 0 ? void 0 : bannerList[(0,floor/* default */.Z)((index + 1) / 10)]
                                                            }) : ""
                                                        ]
                                                    }, article._id);
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider/* Solid */.D, {
                                                    mt: {
                                                        xs: 18,
                                                        xl: 24
                                                    }
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInMobileBox */.dz, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle/* default */.Z, {
                                                mt: 12
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    item: true,
                                    xs: 12,
                                    lg: 4,
                                    px: {
                                        md: 8,
                                        lg: 0
                                    },
                                    pl: {
                                        lg: 20,
                                        xl: 24,
                                        xxl: 38,
                                        maxLimit: 41
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleClassifications/* default */.Z, {
                                            mt: {
                                                xs: 12,
                                                lg: 0
                                            }
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(GuessLikesList/* default */.Z, {
                                            keyword: articlesIds,
                                            mt: 12
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hidden/* HideInDesktopBox */.aI, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LatestArticle/* default */.Z, {
                                                mt: 12
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                (webview === null || webview === void 0 ? void 0 : webview.name) !== "lsApp" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer["default"], {})
            ]
        })
    });
};
/* harmony default export */ var Article_VenderId = (VenderId);

// EXTERNAL MODULE: ./utils/withLivingSinyi.js + 8 modules
var withLivingSinyi = __webpack_require__(93756);
// EXTERNAL MODULE: ./components/common/NoindexRemoval/index.js
var NoindexRemoval = __webpack_require__(84070);
;// CONCATENATED MODULE: ./pages/article/vender-id/[venderUrlId].js




const SearchByTagPage = (props)=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NoindexRemoval/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Article_VenderId, {
                ...props
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _venderUrlId_ = ((0,withLivingSinyi/* default */.Z)(SearchByTagPage));


/***/ }),

/***/ 20227:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ useVenderById; }
/* harmony export */ });
/* harmony import */ var utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(86700);

const useVenderById = (id)=>{
    return (0,utils_hooks_fetchers__WEBPACK_IMPORTED_MODULE_0__/* .useCustomSWR */ .LW)(id && "/venders/".concat(id));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3829,5897,9072,9477,231,5616,9705,318,168,6102,9531,3756,6245,6007,7266,9542,9507,9774,2888,179], function() { return __webpack_exec__(11308); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);